import React, {Fragment} from 'react';
import {DI} from 'modules';

function LiveLogin(props) {
    const string = (key) => {
        return props.common.strings[`page.lives.view.${key}`];
    };

    const signIn = (ev) => {
        ev.preventDefault();
        props.actions.common.openSignInModal();
    };

    const signUp = (ev) => {
        ev.preventDefault();
        props.actions.common.openSignUpModal();
    };

    return (
        <Fragment>
            <div className="live-login">
                <button type="button" className="button" onClick={signIn}>
                    {string(
                        props.liveOrNext ? 'login_and_book' : 'login_and_follow'
                    )}
                </button>
            </div>
            <div className="live-not-registered">
                <span className="live__not-registered">
                    {string('new_to_ruptly')}
                    <a href="#" onClick={signUp}>
                        {string('create_ruptly_account')}
                    </a>
                </span>
            </div>
        </Fragment>
    );
}

export default DI()(LiveLogin);
